import { Observable } from 'rxjs';
import {
  ApiService,
  CREATE_USER_PENALTY_PATH,
  CreateUserPenaltyBody,
  CreateUserPenaltyPathParams,
  GET_USER_PENALTIES_PATH,
  GetUserPenaltiesPathParams,
  GetUserPenaltiesResponse,
  REVOKE_USER_PENALTY_PATH,
  RevokeUserPenaltyPathParams,
  RevokeUserPenaltyResponse
} from '@core-http';

export class PenaltiesService extends ApiService {
  addCard(payload: CreateUserPenaltyBody, pathParams: CreateUserPenaltyPathParams): Observable<void> {
    const path: string = this.fillPathParams(CREATE_USER_PENALTY_PATH, pathParams);

    return this.httpClient.post<void>(`${this.env.apiUrl}${path}`, payload);
  }

  getPenalties(pathParams: GetUserPenaltiesPathParams): Observable<GetUserPenaltiesResponse> {
    const path: string = this.fillPathParams(GET_USER_PENALTIES_PATH, pathParams);

    return this.httpClient.get<GetUserPenaltiesResponse>(`${this.env.apiUrl}${path}`);
  }

  revokeCard(pathParams: RevokeUserPenaltyPathParams): Observable<RevokeUserPenaltyResponse> {
    const path: string = this.fillPathParams(REVOKE_USER_PENALTY_PATH, pathParams);

    return this.httpClient.delete<RevokeUserPenaltyResponse>(`${this.env.apiUrl}${path}`);
  }
}
